module.exports = __webpack_public_path__ + "assets/img/B.f0131a4e.png";